module.exports = __webpack_public_path__ + "img/arrow-up-triangle-square.ca2a4b43.svg";